import { DetailCard } from "../detail-card";
import { DonutChart } from "@mantine/charts";
import { useTranslation } from "react-i18next";
import useSWR from "swr";
import { ReturnAnalyticsApi } from "../../../apis";

const COLORS = [
  "green.6", "blue.6", "orange.6", "grape.6", "gray.6",
  "indigo.6", "pink.6", "teal.6", "violet.6", "lime.6"
];

interface IProps {
  dateFromIso?: string;
  dateToIso?  : string;
}

export function ResolutionBreakdownChart({ dateFromIso, dateToIso }: IProps) {
  const { t } = useTranslation("returns");
  const { data } = useSWR(
    ["returns.breakdown.resolution", dateFromIso, dateToIso],
    () => ReturnAnalyticsApi.breakdown({ dimension: "resolution", dateFrom: dateFromIso, dateTo: dateToIso }),
    { revalidateOnFocus: false }
  );

  const slices = (data?.buckets ?? []).map((b, i) => ({
    name : b.bucket ? t(`resolutionType.${b.bucket}`, { defaultValue: b.bucket }) : "—",
    value: b.count,
    color: COLORS[i % COLORS.length]
  }));

  const total = slices.reduce((s, x) => s + x.value, 0);

  return (
    <DetailCard title={t("dashboard.resolutionBreakdown.title")}>
      <DonutChart
        h={240}
        data={slices}
        chartLabel={t("dashboard.chartLabel.returns", { count: total })}
        withTooltip
      />
    </DetailCard>
  );
}
